import {cn} from '@rocket-ui/tools';
import React, {FC, JSX} from 'react';
import {ButtonIcon, IconType} from './ButtonIcon';
import {sizeClasses, variantClasses} from './config';
import {ButtonSize, ButtonVariant} from './types';

interface Props {
	icon: IconType;
	variant?: ButtonVariant;
	size?: ButtonSize;
	round?: boolean;
	loading?: boolean;
	disabled?: boolean;
}

export type IconButtonProps = Props & Omit<JSX.IntrinsicElements['button'], 'children'>;

export const IconButton: FC<IconButtonProps> = ({icon, variant = 'tonal', size = 'md', round, loading, className, ...props}) => (
	<button
		type="button"
		className={cn(
			'grid place-content-center',
			round ? 'rounded-full' : 'rounded-md',
			variantClasses[variant],
			sizeClasses[size].width,
			sizeClasses[size].height,
			className,
		)}
		{...props}
	>
		<ButtonIcon icon={loading ? 'loading' : icon} className={cn(sizeClasses[size].icon.sizes)} />
	</button>
);
